import { render, staticRenderFns } from "./motherPackageType.vue?vue&type=template&id=21d7a88a&scoped=true&"
import script from "./motherPackageType.vue?vue&type=script&lang=js&"
export * from "./motherPackageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d7a88a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d7a88a')) {
      api.createRecord('21d7a88a', component.options)
    } else {
      api.reload('21d7a88a', component.options)
    }
    module.hot.accept("./motherPackageType.vue?vue&type=template&id=21d7a88a&scoped=true&", function () {
      api.rerender('21d7a88a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/motherPackageType.vue"
export default component.exports